import { render, staticRenderFns } from "./ContactPreferencesSettings.vue?vue&type=template&id=752aa83e&scoped=true&"
import script from "./ContactPreferencesSettings.vue?vue&type=script&lang=js&"
export * from "./ContactPreferencesSettings.vue?vue&type=script&lang=js&"
import style0 from "./ContactPreferencesSettings.vue?vue&type=style&index=0&id=752aa83e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752aa83e",
  null
  
)

export default component.exports